module.exports = __webpack_public_path__ + "img/mingcute-back-line.c6f1d72a.svg";